import React, { Component } from 'react'
import ScrollPicker from './ScrollPicker'
import { debounce } from './services/utils'
import { injectIntl, FormattedHTMLMessage } from 'react-intl'

import { BirthdayIcon } from './Icons'

import './BirthDatePicker.css'

const STARTING_MONTH = 6
const DEFAULT_YEAR_SUBTRACT = 10

const transformMonth = labels => x => labels[x - 1]

const updateRangesAndSelected = rangesAndSelection => prevState => ({
  ...rangesAndSelection
})

const isBetween = (x, from, to) => x >= from && x <= to

const lastDayOfMonth = (year, month) => new Date(year, month, 0).getDate()

const getSelectedValues = (currentValue, from, to, defaultValue) =>
  currentValue !== undefined && isBetween(currentValue, from, to)
    ? { selected: currentValue, autoSelected: true }
    : isBetween(defaultValue, from, to)
      ? { selected: defaultValue, autoSelected: false }
      : { selected: from, autoSelected: false }

const constraint = (year, month) => (maxYear, maxMonth, value, defaultValue) =>
  year === maxYear && month === maxMonth ? value : defaultValue

export default injectIntl(
  class BirthDatePicker extends Component {
    state = {
      fromMonth: 1,
      toMonth: 12,
      fromDate: 1,
      selectedMonth: STARTING_MONTH,
      autoSelectedMonth: false,
      autoSelectedDate: false
    }

    constructor(props) {
      super(props)
      this.yearChanged = debounce(this.yearChanged, 400)
      this.monthChanged = debounce(this.monthChanged, 400)
      this.dateChanged = debounce(this.dateChanged, 400)
    }

    shouldComponentUpdate(nextProps, nextState) {
      const { min, max, onChanged } = this.props
      return (
        this.state !== nextState ||
        min !== nextProps.min ||
        max !== nextProps.max ||
        onChanged !== nextProps.onChanged
      )
    }

    updateBirthday = () => {
      const { onChanged } = this.props
      onChanged(
        this.year,
        this.month !== undefined ? this.month - 1 : this.month,
        this.date
      )
    }

    updateState = () => {
      const { min, max } = this.props

      const fromMonth = this.year === max.year ? max.month : 1
      const toMonth = this.year === min.year ? min.month : 12

      const monthSelectedValues = getSelectedValues(
        this.month,
        fromMonth,
        toMonth,
        STARTING_MONTH
      )

      const selectedMonth = monthSelectedValues.selected
      const autoSelectedMonth = monthSelectedValues.autoSelected
      const lastDate = lastDayOfMonth(this.year, selectedMonth)
      const currentConstraint = constraint(this.year, selectedMonth)
      const fromDate = currentConstraint(max.year, max.month, max.date, 1)
      const toDate = currentConstraint(min.year, min.month, min.date, lastDate)

      if (this.month !== selectedMonth) {
        this.month = undefined
        this.date = undefined
      }

      const dateSelectedValues = getSelectedValues(
        this.date,
        fromDate,
        toDate,
        Math.round(toDate / 2)
      )

      const selectedDate = dateSelectedValues.selected
      const autoSelectedDate =
        autoSelectedMonth && dateSelectedValues.autoSelected

      if (this.date !== selectedDate) {
        this.date = undefined
      }

      this.setState(
        updateRangesAndSelected({
          fromMonth,
          toMonth,
          fromDate,
          toDate,
          selectedMonth,
          selectedDate,
          autoSelectedMonth,
          autoSelectedDate
        })
      )
    }

    yearChanged = value => {
      this.year = value !== undefined ? Number(value) : undefined
      this.updateState()
      this.updateBirthday()
    }

    monthChanged = value => {
      this.month = value !== undefined ? Number(value) : undefined
      this.updateState()
      this.updateBirthday()
    }

    dateChanged = value => {
      this.date = value !== undefined ? Number(value) : undefined
      this.updateBirthday()
    }

    componentWillMount() {
      const { min, max } = this.props
      if (min === undefined || max === undefined) return

      const toDate = lastDayOfMonth(
        min.year - DEFAULT_YEAR_SUBTRACT,
        STARTING_MONTH
      )

      this.setState(
        updateRangesAndSelected({
          toDate,
          selectedDate: Math.round(toDate / 2)
        })
      )
    }

    renderScrollPickers() {
      const { min, max, intl } = this.props
      const {
        fromMonth,
        toMonth,
        fromDate,
        toDate,
        selectedMonth,
        selectedDate,
        autoSelectedMonth,
        autoSelectedDate
      } = this.state

      if (min !== undefined && max !== undefined) {
        return [
          <ScrollPicker
            key="year"
            from={max.year}
            to={min.year}
            itemWidth={90}
            defaultValue={min.year - 10}
            autoSelected={true}
            onChanged={this.yearChanged}
          />,
          <ScrollPicker
            key="month"
            from={fromMonth}
            to={toMonth}
            itemWidth={120}
            defaultValue={selectedMonth}
            transform={transformMonth(intl.messages.months)}
            autoSelected={autoSelectedMonth}
            onChanged={this.monthChanged}
          />,
          <ScrollPicker
            key="date"
            from={fromDate}
            to={toDate}
            itemWidth={50}
            defaultValue={selectedDate}
            autoSelected={autoSelectedDate}
            onChanged={this.dateChanged}
          />
        ]
      }
    }

    render() {
      return (
        <div className="cm-birthdatepicker">
          <div className="cm-birthdatepicker--title">
            <BirthdayIcon className="cm-birthdatepicker--picto" />
            <FormattedHTMLMessage id="the_birthdate" />
          </div>
          {this.renderScrollPickers()}
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/BirthDatePicker.js